import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

async function captureElement(elementId) {
  const el = document.getElementById(elementId);
  if (!el) return null;
  return html2canvas(el, { backgroundColor: '#0f172a', scale: 2 });
}

export async function exportPNG(elementId = 'sprint-board-export') {
  const canvas = await captureElement(elementId);
  if (!canvas) return;

  const link = document.createElement('a');
  link.download = 'sprint-board.png';
  link.href = canvas.toDataURL('image/png');
  link.click();
}

export async function exportPDF(elementId = 'sprint-board-export') {
  const canvas = await captureElement(elementId);
  if (!canvas) return;

  const imgData = canvas.toDataURL('image/png');
  const pdf = new jsPDF({
    orientation: 'landscape',
    unit: 'px',
    format: [canvas.width / 2, canvas.height / 2],
  });

  pdf.addImage(imgData, 'PNG', 0, 0, canvas.width / 2, canvas.height / 2);
  pdf.save('sprint-board.pdf');
}
